<template>
  <div>
    <b-button :class="[showGeolocated ? 'btn-info' : 'btn-secondary','offset-2col-8 mb-2']" v-model="showGeolocated" :pressed.sync="showGeolocated">
      <i class="fa-map-marker-alt fas"></i>&nbsp;{{ showGeolocated ? "Désactiver " : "Activer "}} la géolocalisation
    </b-button>
    <div class="form-group">
      <h3>Localisation</h3>
      <div v-show="!showGeolocated">
        <h4 v-if="communes.length == 1">Commune : {{ selectedCommune }}</h4>
        <div v-else>
          <div v-if="selectedCommune == '' || selectedCommune == null">
            <h4>Communes :</h4>
            <button v-for="commune in communes?.sort()" :key="commune" :disabled="communes.length == 1"
                    class="btn btn-outline-secondary d-inline-block my-2 m-2"
                    v-bind:class="{ active: selectedCommune == commune }"
                    @click="updateCommune(commune)">
              {{ commune }}
            </button>
          </div>
          <div v-else>
            <h4 class="mb-0">Commune : {{ selectedCommune }}</h4>
            <button class="btn btn-sm btn-primary py-0 mb-3 mt-1"
                    @click="selectedCommune = '';selectedQuartier = ''; selectedRue = ''">
              <i class="fas fa-redo"></i>
            </button>
          </div>
        </div>
        <div v-if="selectedCommune != '' && selectedCommune != null">
          <hr>
          <h4 v-if="quartiers.length == 1">Quartier : {{ selectedQuartier }}</h4>
          <div v-else>
            <div v-if="selectedQuartier == '' || selectedQuartier == null">
              <h4>Quartiers :</h4>
              <button v-for="quartier in quartiers.sort()" :key="quartier" :disabled="quartiers.length == 1"
                      class="btn btn-outline-secondary d-inline-block my-2 mx-2"
                      v-bind:class="{ active: selectedQuartier == quartier }"
                      @click="updateQuartier(quartier)">
                {{ quartier }}
              </button>
            </div>
            <div v-else>
              <h4 class="mb-0">Quartier : {{ selectedQuartier }}</h4>
              <button class="btn btn-sm btn-primary py-0 mb-3 mt-1" @click="selectedQuartier = ''; selectedRue = ''">
                <i class="fas fa-redo"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-if="selectedQuartier != '' && selectedQuartier != null">
          <hr>
          <h4 v-if="rues.length == 1">Rue : {{ selectedRue }}</h4>
          <div v-else>
            <div v-if="selectedRue == '' || selectedRue == null">
              <h4>Rues :</h4>
              <button v-for="rue in rues.sort()" :key="rue" :disabled="rues.length == 1"
                      class="btn btn-outline-secondary d-inline-block my-2 mx-2"
                      v-bind:class="{ active: selectedRue == rue }"
                      @click="selectedRue = rue">
                {{ rue }}
              </button>
            </div>
            <div v-else>
              <h4 class="mb-0">Rue : {{ selectedRue }}</h4>
              <button class="btn btn-sm btn-primary py-0 mb-3 mt-1" @click="selectedRue = ''">
                <i class="fas fa-redo"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-if="selectedRue != '' && selectedRue != null" class="container-fluid">
          <hr>
          <h4>Adresses :</h4>
          <a id="link-go-to-address" v-smooth-scroll="{ duration: 1000, offset: -50 }" href="#go-to-address"></a>
          <div id="go-to-address" class="row"></div>
          <button v-for="propositionEntree in propositionsEntrees" :key="propositionEntree.id"
                  class="btn btn-outline-secondary d-inline-block my-2 col-12"
                  @click="setSelectedEntreeAndRedirectToFormulaire(propositionEntree.id)">
            <div class="row">
              <span class="col-12">{{ propositionEntree.numeroRue }} {{ propositionEntree.rue }}</span>
            </div>
  <!--          <span>{{propositionEntree.categorieLogements}}</span>-->
            <div class="row">
              <small class="col-3 offset-1 font-italic mb-0 text-left text-success pl-0" style="font-size: 0.8em;">Esc. {{ propositionEntree.lesc }}</small>
              <small class="col-7 offset-1 font-italic mb-0 text-right text-success pl-0" style="font-size: 0.7em;">{{propositionEntree.categorieLogements}}</small>
            </div>

          </button>
        </div>
      </div>
      <div v-if="showGeolocated" class="container-fluid">
        <hr>
          <h4>Adresses :</h4>
          <a id="link-go-to-address" v-smooth-scroll="{ duration: 1000, offset: -50 }" href="#go-to-address"></a>
          <div id="go-to-address"></div>
          <button v-for="propositionEntree in propositionsEntreesGeolocated" :key="propositionEntree.id"
                  class="btn btn-outline-secondary d-inline-block my-2 mx-2 py-1 px-2 col-12"
                  style="font-size:0.9em;"
                  @click="setSelectedEntreeAndRedirectToFormulaire(propositionEntree.id)">
                  <div class="row mx-1">
                    {{ propositionEntree.numeroRue }} {{ propositionEntree.rue }} - {{ propositionEntree.commune }} 
                  </div>
                  <div class="row">
                    <small class="font-italic mb-0 text-left col-5" style="font-size:1em"><i class="fa-map-marker-alt fas"></i>{{propositionEntree.dist}}Km</small> 
                    <small class="col-2 font-italic text-center text-success pl-0" style="font-size: 0.8em;">Esc. {{ propositionEntree.lesc }}</small>
                    <small class="font-italic mb-0 text-right text-success d-block col-5" style="font-size:0.7em;">{{propositionEntree.categorieLogements}}</small>
                  </div>
          </button>
      </div>
    </div>

  </div>
</template>

<script>
import toast from '../../js/toast';

export default {
  name: "FormRecla",
  data() {
    return {
      categorie: this.$store.getters['categories/selectedCategory'],
      type: this.$store.getters['types/selectedType'],
      nature: this.$store.getters['natures/selectedNature'],
      motif: this.$store.getters['motifs/selectedMotif'],
      selectedCommune: '',
      selectedQuartier: '',
      selectedRue: '',
      showGeolocated: false,
      longitude:0,
      latitude:0
    }
  },
  methods: {
    setSelectedEntreeAndRedirectToFormulaire(entreeID) {
      this.$store.dispatch('entrees/setSelectedEntree', entreeID)
      this.$router.push({name: 'formulaire'})
    },
    goToPropositionAdresse() {
      document.getElementById("link-go-to-address").click();
    },
    updateCommune(commune) {
      this.selectedCommune = commune
      if (this.quartiers.length === 1) this.selectedQuartier = this.quartiers[0]
      if (this.rues.length === 1) this.selectedRue = this.rues[0]
    },
    updateQuartier(quartier) {
      this.selectedQuartier = quartier
      if (this.rues.length === 1) this.selectedRue = this.rues[0]
    },
    getGeolocalisation() {
      //Tente de définir les coordonnées GPS de l'utilisateur
      if (this.showGeolocated) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.longitude = pos.coords.longitude;
            this.latitude = pos.coords.latitude;
          },
          (err) => {
            this.longitude = 0;
            this.latitude = 0;
            toast.showToast(
              "error",
              "Erreur de géolocalisation: " + err.message
            );
          }
        );
      }
    }
  },
  computed: {
    communes() {
      return this.$store.getters['entrees/getAllCommunes']
    },
    quartiers() {
      return this.$store.getters['entrees/getQuartiersByCommune'](this.selectedCommune)
    },
    rues() {
      return this.$store.getters['entrees/getRueByQuartier'](this.selectedQuartier)
    },
    propositionsEntrees() {
      return this.$store.getters['entrees/getEntreeByCommuneQuartierRue'](this.selectedCommune, this.selectedQuartier, this.selectedRue)
    },
    propositionsEntreesGeolocated() {
      this.getGeolocalisation();
      return this.$store.getters['entrees/getEntreesByGeolocation'](this.latitude, this.longitude).slice(0, 99);
    }
  },
  mounted: function () {
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      let sollicitation = this.$store.getters['sollicitations/getSollicitationById'](this.$route.params.sollicitation)[0]
      this.selectedCommune = this.$store.getters['entrees/getEntreeByID'](sollicitation.entree)[0].commune
      this.$store.dispatch('entrees/setSelectedEntree', sollicitation.entree)
      this.$router.push({
        name: 'formulaire',
        params: {sollicitation: this.$route.params.sollicitation}
      })
    } else {
      if (this.communes.length === 1) this.selectedCommune = this.communes[0]
      if (this.quartiers.length === 1) this.selectedQuartier = this.quartiers[0]
      if (this.rues.length === 1) this.selectedRue = this.rues[0]
      this.$store.dispatch('entrees/setSelectedEntree', null)
    }
  }
}
</script>

<style scoped>
.active {
  background-color: #28a745;
}
</style>
